<template>
<v-container fluid fill-height>
    <v-layout justify-center>
        <v-responsive max-width="1024px" width="100%" height="100%">
            <v-row class="mt-4">
                <v-col cols="12" md="6">
                    <v-card>
                        <v-toolbar color="info lighten-1" dense>
                            <v-toolbar-title class="white--text subtitle-2">카테고리</v-toolbar-title>

                            <v-spacer></v-spacer>
                            
                            <v-fab-transition>
                                <v-btn color="accent" fab dark small absolute bottom right @click="dialog = true">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-fab-transition>
                        </v-toolbar>

                        <v-card-text>
                            <v-draggable-treeview v-if="categories.length" v-model="categories" item-key="_id" children="platforms" group="categories" @click="change" dense></v-draggable-treeview>
                            <span v-else>등록된 카테고리가 없습니다.<br>카테고리를 등록해주세요</span>
                        </v-card-text>
                    </v-card>

                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col md="auto">

                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card :disabled="!category._id">
                        <v-card-title class="subtitle-1">카테고리 기본정보</v-card-title>
                        <v-card-text>
                            <v-row class="mt-3">
                                <v-col class="py-0">
                                    <v-text-field v-model="category.name" label="카테고리 이름" placeholder=" " dense hide-details></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-row>
                        <v-col md="auto">
                            <v-btn color="grey darken-1" class="white--text" @click="remove(category)" :disabled="!category._id || category.root ? true : false">삭제</v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col md="auto">
                            <v-btn color="primary" @click="update" :disabled="!category._id">저장</v-btn>
                        </v-col>
                    </v-row>

                </v-col>
            </v-row>

            <v-dialog v-model="dialog" width="560">
                <v-card v-if="dialog">
                    <v-card-title class="subtitle-1" primary-title>신규 카테고리 & 플랫폼</v-card-title>

                    <v-card-text>
                        <v-row class="mt-3">
                            <v-col class="py-0">
                                <v-select v-model="selectedItem" label="카테고리" placeholder=" " :items="[{ _id: null, name: '없음' }].concat(categories)" item-text="name" item-value="_id" return-object></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-3">
                            <v-col class="py-0">
                                <v-text-field v-model="editItem.name" label="이름" placeholder=" " dense hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="dialog = false">취소</v-btn>
                        <v-btn color="primary" text @click="save">등록</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-responsive>
    </v-layout>

</v-container>
</template>

<script>
import api from "@/api";
import VDraggableTreeview from "@/components/plugins/vuetify/vuetify-draggable-treeview/DraggableTreeview.vue";

export default {
    components: {
        VDraggableTreeview,
    },
    data() {
        return {
            dialog: false,

            loading: true,

            headers: [],
            categories: [],
            category: {
                banners: []
            },

            editItem: null,
            selectedItem: { _id: null },
            defaultItem: {
                name: null,
            },

            banner: null,
            pickup: null
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();

            this.loading = false;
        },

        async search(){
            try{
                var { me } = await api.console.me.get();
                this.categories = me.categories;
            }
            catch(error){
                console.error(error);
            }
        },

        async change(category){
            try{
                if(category.icon && !this.createObjectURL(category.icon)) category.icon = await api.getResource(category.icon);
                for(var index in category.banners){
                    if(category.banners[index] && !this.createObjectURL(category.banners[index])) category.banners[index] = await api.getResource(category.banners[index]);
                }
            }
            catch(error){
                console.error(error);
                // alert(error.response ? error.response.data.message : error.message);
            }
            this.category = category;
        },

        /////////////////////////////////////////
        // 카테고리 등록
        /////////////////////////////////////////
        async save() {
            try {
                this.selectedItem._id ? this.selectedItem.platforms = [...this.selectedItem.platforms, this.editItem] : this.categories.push(this.editItem);

                var categories = JSON.parse(JSON.stringify(this.categories));

                console.log({ categories });

                await api.console.me.put({ categories });

                await this.search();
                
                this.dialog = false;
            }
            catch (error) {
                console.error(error);
            }
        },

        /////////////////////////////////////////
        // 카테고리 수정
        /////////////////////////////////////////
        async update() {
            try {
                await api.console.me.put({
                    categories: this.categories
                });
            } catch (error) {
                console.error(error);
            }
        },

        /////////////////////////////////////////
        // 카테고리 삭제
        /////////////////////////////////////////
        async remove(item) {
            try {
                for(var category of this.categories){
                    if(category == item) this.categories.splice(this.categories.indexOf(category), 1);
                    for(var platform of category.platforms){
                        if(platform == item) category.platforms.splice(category.platforms.indexOf(platform), 1);
                    }
                }

                await api.console.me.put({
                    categories: this.categories
                });
            } catch (error) {
                console.error(error);
            }
        },
    },
    watch: {
        dialog(value){
            if(value) this.editItem = Object.assign({}, this.defaultItem);
        },
        categories() {
            if(!this.loading) this.update();
        }
    }
}
</script>
